import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion, faBookOpen, faFileLines, faPlus, faBuilding } from "@abodeminehq/parcel-ui/icons/fa/pro-solid";
import { Button, HStack } from "@abodeminehq/parcel-ui";
import { createFileRoute, Link } from '@tanstack/react-router'
import { ContentUnavailableView } from '~/components/layouts/ContentUnavailableView'
import { SummeryContentLayout, SummeryContentLayoutContent, SummeryContentLayoutHeader } from '~/components/layouts/SummeryContentLayout'
import { useAuthScopes } from '~/hooks/use-auth-scopes'
import { LogtoScopes } from '~/lib/logto/logto'
import { useDocuments } from '~/lib/queries/guide-documents'
import { useGuideSidebarContext } from '~/contexts/guide-sidebar-context'
import { useIsMobile } from '~/hooks/use-mobile'
import { useHasActiveOrg } from '~/hooks/use-has-active-org'

export const Route = createFileRoute('/docs/guide/')({
  component: RouteComponent,
})

function RouteComponent() {

  const { data, isLoading, error } = useDocuments()
  const { setOpen } = useGuideSidebarContext()
  const isMobile = useIsMobile()

  const hasGuideWriteScopes = useAuthScopes(LogtoScopes.GuideWrite)
  // Show different content based on access level
  const hasGuideReadScopes = useAuthScopes(LogtoScopes.GuideRead)
  const { hasActiveOrg, isLoading: isLoadingActiveOrgCheck } = useHasActiveOrg()

  if (isLoading || isLoadingActiveOrgCheck) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  // Check for active organization access
  if (!hasActiveOrg) {
    return (
      <div className="h-full w-full flex justify-center items-center">
        <ContentUnavailableView
          title="No Active Organizations"
          description="You must be part of an active organization to access guides. Please contact your organization administrator."
          icon={faBuilding}
        />
      </div>
    )
  }
  
  if (!hasGuideReadScopes && !hasGuideWriteScopes) {
    return (
      
      <div className="h-full w-full flex justify-center items-center">
        <ContentUnavailableView
          title="Access Denied"
          description="You don't have permission to view guides"
          icon={faCircleQuestion}
        />
      </div>
    )
  }

  const title = (data?.documents.length ?? 0) > 0 ? 'No Guides Open' : 'No Guides Found'
  const description = (data?.documents.length ?? 0) > 0 ? 'Select or create a Guide to get started' : 'Create a new Guide to get started'
  
  return (
    <SummeryContentLayout>
    <SummeryContentLayoutHeader 
      title="Guides" 
      leadingActions={
        isMobile ? (
          <>
            <Button variant="ghost" size="sm" onClick={() => {
                setOpen(true)
              }}>
                <FontAwesomeIcon icon={faBookOpen} className="h-4 w-4" />
            </Button>
          </>
        ) : undefined
      }
    />
        <SummeryContentLayoutContent>
    <div className="h-full w-full flex justify-center items-center">
      <ContentUnavailableView
        title={title}
        description={description}
        icon={faFileLines}
      >
        {hasGuideWriteScopes && (
          <Link to="/docs/guide/$slug" params={{ slug: 'new' }}>
            <Button variant="outline" asChild>
              <HStack>
                <FontAwesomeIcon icon={faPlus}/>
                Create a new Guide
              </HStack>
            </Button>
          </Link>
        )}
      </ContentUnavailableView>

      
    </div>
    </SummeryContentLayoutContent>
    </SummeryContentLayout>
  )
}
